module.exports = __webpack_public_path__ + "static/end_of_chapter_background-6061b602d47b9119991fb0dc931dfe6f.png";